export enum StoreProfileEnum {
  MASTER_ADMIN = 'masterAdmin',
  GROUP_ADMIN = 'groupAdmin',
  STORE = 'store',
  ONLINE = 'online',
  IN_APP = 'inApp',
  LOM = 'LOM',
  EMPTY = ''
}
